export class ContactUsModel {
	entityId: number;
	entityNameId: number;
	message: string;
	conversationId: number;
	dataOriginId: number;
	conversationCategoryId: number;
	otherDescription: string;
	conversationResponseTypeId: number;
	conversationTypeId: number;
	phoneNumber: string;
	linkedEntityNameId: number | null | undefined;
	linkedEntityId: number | null | undefined;
	messageProperties: string;
	messageEntityNameId: number | null | undefined;
	messageEntityId: number | null | undefined;
	contactTimeId?: number | null | undefined;
}
